import axios from 'axios';
import Config from '../../config';
import {flashMessage} from 'redux-flash';

export function single(id) {
    return (dispatch) => {
        return axios.get(Config.api.endpoint + 'api/Workspace/', Config.getApiConfig()).then(response => {
            if (response) {
                dispatch({
                    type: 'WORKSPACE_SINGLE_SUCCESS',
                    payload: {
                        data: response.data[0]
                    }
                });

                dispatch({
                    type: '@@redux-form/INITIALIZE',
                    meta: {
                        form: 'WorkspaceForm',
                        keepDirty: undefined
                    },
                    payload: response.data
                });

                return response;
            }
        })
    }
}

export function get() {
    return (dispatch) => {
        return axios.get(Config.api.endpoint + 'api/Workspace', Config.getApiConfig()).then(response => {
            if (response) {
                dispatch({
                    type: 'WORKSPACE_GET_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch({
                    type: 'WORKSPACE_REFRESH_FALSE'
                });

                return response;
            }
        })
    }
}

export function post(values) {
    return (dispatch) => {
        return axios.post(Config.api.endpoint + 'api/Workspace', values, Config.getApiConfig()).then(response => {
            if (response) {
                dispatch({
                    type: 'WORKSPACE_POST_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch({
                    type: 'WORKSPACE_REFRESH_TRUE'
                });

                dispatch(flashMessage('Workspace created!', {timeout: 3000, props: {type: 'success'}}));

                return response;
            }
        })
    }
}

export function put(id, values) {
    return (dispatch) => {
        return axios.put(Config.api.endpoint + 'api/Content/structure/' + id + '/page', values, Config.getApiConfig()).then(response => {
            if (response) {
                dispatch(single(id));

                dispatch({
                    type: 'WORKSPACE_PUT_SUCCESS',
                    payload: {
                        data: response.data
                    }
                });

                dispatch({
                    type: 'WORKSPACE_REFRESH_TRUE'
                });

                dispatch(flashMessage('Workspace updated!', {timeout: 3000, props: {type: 'success'}}));

                return response;
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/core/store/actions/workspace.js